<div class="nadlan-listings-container" dir="rtl">
  <!-- Header -->
  <header class="listings-header">
    <div class="header-content" (click)="navigateToPage()">
      <div class="header-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
      </div>
      <div>
        <h2>נדל״ן</h2>
        <!-- Count folded into the subtitle: it's passive information,
        so it belongs with the description rather than occupying
        its own pill alongside the real actions. -->
        <p class="subtitle">
          <span class="subtitle-text">דירות למכירה, להשכרה ועוד</span>@if (listings.length) {
          <span
          class="subtitle-count">{{ listings.length }} מודעות</span>
        }
      </p>
    </div>
  </div>
  <div class="header-actions">
    @if (listings.length > 0) {
      <div class="scroll-arrows">
        <button class="arrow-btn" (click)="scrollLeft()" aria-label="מודעות הנדלן הבאות">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>
        </button>
        <button class="arrow-btn" (click)="scrollRight()" aria-label="מודעות הנדלן הקודמות">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>
        </button>
      </div>
    }
    <button type="button" class="view-all-btn" (click)="navigateToPage()">לכל המודעות</button>
  </div>
</header>

<!-- Loading -->
@if (isLoading) {
  <div class="loading-state">
    <div class="dot-loader"><span></span><span></span><span></span></div>
    <p>טוען נכסים...</p>
  </div>
}

<!-- Error -->
@if (error && !isLoading) {
  <div class="error-state">
    <p>אופס! משהו השתבש</p>
    <button (click)="loadListings()" class="retry-btn">נסה שוב</button>
  </div>
}

<!-- Scroll Track -->
@if (!isLoading && !error && listings.length > 0) {
  <div class="scroll-wrapper">
    <div class="nadlan-track" #nadlanTrack dragScroll>
      @for (item of listings; track item; let i = $index) {
        <div
          class="nadlan-card"
          [class.promoted]="isPromoted(item)"
          [style.animation-delay]="i * 60 + 'ms'"
          (click)="openPage(item.id)"
          role="button"
          tabindex="0"
          [attr.aria-label]="'פתיחת מודעת נדלן: ' + item.name"
          (keydown.enter)="openPage(item.id)"
          (keydown.space)="openPage(item.id); $event.preventDefault()"
          >
          <!-- Internal (admin) ad linked to this category — generic layout, -->
          <!-- since it doesn't have any of the nadlan-specific fields below -->
          @if (isInternalAd(item)) {
            <div class="card-image">
              <img
                [src]="item.images[0]?.image || 'https://placehold.co/400x260/e8e4df/8a8580?text=🏠'"
                [alt]="item.name"
                (error)="onImageError($event)"
                />
              <span class="price-tag" [class.no-price]="!item.price">{{ formatPrice(item.price) }}</span>
            </div>
            <div class="card-body">
              <div class="title-row">
                <h3>{{ item.name }}</h3>
              </div>
              @if (item.description) {
                <p class="internal-ad-desc">{{ item.description }}</p>
              }
              @if (item.city) {
                <div class="address">{{ item.city.nameHe }}</div>
              }
              <div class="card-footer">
                <span class="seller">{{ item.userContactDetails?.contactPerson }}</span>
                <app-contact-menu
                  [phone]="item.userContactDetails?.phoneNumber || ''"
                  [itemName]="item.name"
                  [itemId]="item.id"
                  [accentColor]="'#0d9488'"
                ></app-contact-menu>
              </div>
            </div>
          } @else {
            <!-- Image -->
            <div class="card-image">
              <img
                [src]="item.images[0]?.image || 'https://placehold.co/400x260/e8e4df/8a8580?text=🏠'"
                [alt]="item.name"
                (error)="onImageError($event)"
                />
              <span class="price-tag" [class.no-price]="!item.price">{{ formatPrice(item.price) }}</span>
              <span class="type-tag" [class.rental]="item.sconderyCategory?.subCategory === 'RENTAL'">
                {{ getCategoryIcon(item.sconderyCategory?.subCategory) }} {{ getCategoryLabel(item.sconderyCategory?.subCategory) }}
              </span>
              @if (isPromoted(item)) {
                <span class="ads-tag">{{ getAdsBadge(item.adsRoute?.level) }}</span>
              }
              <app-card-biz-badges [item]="item"></app-card-biz-badges>
            </div>
            <!-- Body -->
            <div class="card-body">
              <div class="title-row">
                <h3>{{ item.TypeOfNadlan?.nameHe }}{{ item.TypeOfNadlan?.nameHe && item.City?.nameHe ? ' • ' : '' }}{{ item.City?.nameHe }}</h3>
                <span class="status">{{ item.StatusOfNadlan?.nameHe }}</span>
              </div>
              <div class="address">{{ item.Street?.nameHe }}{{ item.Street?.nameHe && item.HomeNum ? ' ' + item.HomeNum : '' }}{{ item.Street?.nameHe && (item.Neighborhood || item.City?.nameHe) ? ', ' : '' }}{{ item.Neighborhood || item.City?.nameHe }}</div>
              <!-- Stats Row -->
              <div class="stats">
                @if (item.RoomsNum?.numberOfRooms) {
                  <div class="stat">
                    <span class="stat-val">{{ item.RoomsNum?.numberOfRooms }}</span>
                    <span class="stat-label">חדרים</span>
                  </div>
                }
                @if (item.Floor !== null) {
                  <div class="stat">
                    <span class="stat-val">{{ item.Floor }}@if (item.TotalFloor) {
                      <span class="of">/{{ item.TotalFloor }}</span>
                    }</span>
                    <span class="stat-label">קומה</span>
                  </div>
                }
                @if (item.buildingMeterTotal) {
                  <div class="stat">
                    <span class="stat-val">{{ item.buildingMeterTotal }}</span>
                    <span class="stat-label">מ״ר</span>
                  </div>
                }
                @if (item.ParkingNumber) {
                  <div class="stat">
                    <span class="stat-val">{{ item.ParkingNumber?.numberParking }}</span>
                    <span class="stat-label">חניה</span>
                  </div>
                }
              </div>
              <!-- Chips -->
              <div class="chips">
                @for (arm of (item.armatureList || []).slice(0, 3); track arm) {
                  <span class="chip accent">{{ arm.ArmatureDesc }}</span>
                }
                @if (item.OnColumns) {
                  <span class="chip">על עמודים</span>
                }
                @if (item.flexible) {
                  <span class="chip">גמיש</span>
                }
                @if (item.condo) {
                  <span class="chip">ועד: ₪{{ item.condo }}</span>
                }
              </div>
              <!-- Footer -->
              <div class="card-footer">
                <app-card-dealer [item]="item"></app-card-dealer>
                <app-contact-menu
                  [phone]="item.userContactDetails?.phoneNumber || ''"
                  [itemName]="item.name"
                  [itemId]="item.id"
                  [accentColor]="'#0d9488'"
                ></app-contact-menu>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}

<!-- Empty -->
@if (!isLoading && !error && listings.length === 0) {
  <div class="empty-state">
    <p>לא נמצאו נכסים</p>
  </div>
}
</div>
